import React from "react";
import { scrollToProgress } from "../config";
import { useLang } from "../i18n";

export default function Nav() {
  const { t, lang, setLang } = useLang();
  return (
    <nav className="bb-interactive fixed top-0 left-0 right-0 z-50">
      <div className="mx-auto max-w-[1200px] px-5 lg:px-10 py-5 flex items-center justify-between">
        <button
          data-testid="nav-wordmark"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="ff-wordmark text-[15px] sm:text-[17px]"
          style={{ color: "var(--bb-ink)", background: "transparent", border: "none", cursor: "pointer" }}
        >
          BriefBref
        </button>
        <div className="flex items-center gap-5 sm:gap-7">
          <button
            data-testid="nav-manifesto"
            onClick={() => scrollToProgress(0.34)}
            className="bb-underline ff-mono hidden sm:inline text-xs uppercase tracking-[0.18em]"
            style={{ color: "var(--bb-ink-muted)", background: "transparent", border: "none", cursor: "pointer" }}
          >
            {t.nav.manifesto}
          </button>
          <button
            data-testid="nav-waitlist"
            onClick={() => scrollToProgress(0.99)}
            className="bb-underline ff-mono text-xs uppercase tracking-[0.18em]"
            style={{ color: "var(--bb-ink-muted)", background: "transparent", border: "none", cursor: "pointer" }}
          >
            {t.nav.waitlist}
          </button>
          <div className="bb-lang">
            <button data-testid="lang-en" data-active={lang === "en"} onClick={() => setLang("en")}>EN</button>
            <span style={{ opacity: 0.35 }}>/</span>
            <button data-testid="lang-fr" data-active={lang === "fr"} onClick={() => setLang("fr")}>FR</button>
          </div>
        </div>
      </div>
    </nav>
  );
}
